import type {
  RegenerateRequest,
  RegenerateResponse,
  RetryResponse,
  TaskDetail,
  TaskListQuery,
  TaskListResponse,
} from '@/types/api';
import { apiFetch } from './client';

export function listTasks(query: TaskListQuery = {}): Promise<TaskListResponse> {
  const params = new URLSearchParams();
  if (query.status) for (const s of query.status) params.append('status', s);
  if (query.phone) params.set('phone', query.phone);
  if (query.session_id) params.set('session_id', query.session_id);
  if (query.started_from) params.set('started_from', query.started_from);
  if (query.started_to) params.set('started_to', query.started_to);
  if (query.direction) params.set('direction', query.direction);
  if (query.order) params.set('order', query.order);
  if (query.limit !== undefined) params.set('limit', String(query.limit));
  if (query.cursor) params.set('cursor', query.cursor);
  const qs = params.toString();
  return apiFetch<TaskListResponse>(`/tasks${qs ? '?' + qs : ''}`);
}

export function getTask(id: number): Promise<TaskDetail> {
  return apiFetch<TaskDetail>(`/tasks/${id}`);
}

export function retryTask(id: number): Promise<RetryResponse> {
  return apiFetch<RetryResponse>(`/tasks/${id}/retry`, { method: 'POST' });
}

export function regenerateTask(
  id: number,
  body: RegenerateRequest = {},
): Promise<RegenerateResponse> {
  return apiFetch<RegenerateResponse>(`/tasks/${id}/regenerate`, {
    method: 'POST',
    json: body,
  });
}
